export const GET_USER = "GET_USER";
export const GET_USER_PENDING = GET_USER + "_PENDING";
export const GET_USER_FULFILLED = GET_USER + "_FULFILLED";
export const GET_USER_REJECTED = GET_USER + "_REJECTED";

export const LOGOUT_USER = "LOGOUT_USER";

export const UPDATE_USER = "UPDATE_USER";
